import React from 'react';
import Navbar from '../components/Navbar';
import TickerTape from '../components/TickerTape';
import Footer from '../components/Footer';
import { CompanyIcon } from '../components/CompanyCard';
import { useApp } from '../context/AppContext';
import { toast } from 'sonner';
import { Clock, Bell, TrendingUp } from 'lucide-react';

export default function PipelinePage() {
  const { pipeline } = useApp();
  return (
    <div className="min-h-screen">
      <TickerTape />
      <Navbar />

      <section className="relative border-b border-[var(--border)] overflow-hidden">
        <div className="absolute inset-0 hero-glow pointer-events-none" />
        <div className="max-w-[1320px] mx-auto px-5 py-14 relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#3f2a5a] bg-[#2a1a3a] text-[10.5px] font-mono tracking-[0.14em] text-[#c084fc]">
            <Clock size={12} /> PIPELINE • UPCOMING UNLISTED MARKETS
          </div>
          <h1 className="font-display font-bold text-[44px] leading-tight tracking-tight text-white mt-6">
            Next unicorns entering the book.
          </h1>
          <p className="text-[15px] text-[var(--muted)] leading-relaxed mt-4 max-w-2xl">
            Indicative pricing and expected order-book open dates for private companies pending onboarding to the ApexForge ATS. Register interest to reserve early allocation.
          </p>
        </div>
      </section>

      <section className="max-w-[1320px] mx-auto px-5 pt-10 pb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {pipeline.map((c) => (
            <div key={c.id} className="rounded-xl bg-[var(--panel)] border border-[var(--border)] p-5 hover:border-[#3a3a42] transition-all duration-200 hover:-translate-y-1">
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-lg bg-[#1c1710] border border-[#3a2a18] flex items-center justify-center">
                    <CompanyIcon name={c.icon} />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-[15px] text-white">{c.name}</h3>
                    <div className="flex items-center gap-1.5 mt-1 text-[11px] font-mono">
                      <span className="text-[var(--orange)]">{c.ticker}</span>
                      <span className="text-[var(--muted-2)]">•</span>
                      <span className="text-[var(--muted)]">{c.category}</span>
                    </div>
                  </div>
                </div>
                <span className="text-[10px] font-mono px-2 py-1 rounded bg-[#2a1a3a] text-[#c084fc] border border-[#3f2a5a]">{c.openDate}</span>
              </div>

              <p className="text-[12.5px] text-[var(--muted)] mt-4 leading-relaxed line-clamp-2">{c.description}</p>

              <div className="grid grid-cols-2 gap-4 mt-5">
                <div>
                  <div className="text-[9.5px] font-mono tracking-[0.12em] text-[var(--muted-2)]">INDICATIVE PRICE</div>
                  <div className="font-mono font-semibold text-[18px] text-[var(--orange)] mt-1">${c.indicativePrice.toFixed(2)}</div>
                </div>
                <div>
                  <div className="text-[9.5px] font-mono tracking-[0.12em] text-[var(--muted-2)]">TARGET VALUATION</div>
                  <div className="font-mono font-semibold text-[18px] text-[var(--salmon)] mt-1">${c.targetValuation.toFixed(1)}B</div>
                </div>
              </div>

              <div className="mt-4">
                <div className="flex items-center justify-between text-[10px] font-mono text-[var(--muted-2)] mb-1.5">
                  <span>INDICATED DEMAND</span><span className="text-[var(--muted)]">{c.demand}%</span>
                </div>
                <div className="h-1.5 rounded-full bg-[var(--bg)] overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-[var(--orange)] to-[#c084fc]" style={{ width: `${c.demand}%` }} />
                </div>
              </div>

              <button
                onClick={() => toast.success('Interest registered', { description: `You'll be notified when ${c.ticker} opens.` })}
                className="w-full mt-5 flex items-center justify-center gap-2 py-2.5 rounded-lg bg-[var(--panel-2)] border border-[var(--border)] text-[12.5px] font-medium text-white hover:border-[var(--orange)] transition-colors"
              >
                <Bell size={14} className="text-[var(--orange)]" /> REGISTER INTEREST
              </button>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
